/**
 * @name trailer
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTEuMzQxVjEwIiAvPgogIDxwYXRoIGQ9Ik0xNCAxM3YtMyIgLz4KICA8cGF0aCBkPSJNMTggMTdWOGEyIDIgMCAwMC0yLTJINGEyIDIgMCAwMC0yIDJ2N2EyIDIgMCAwMDIgMmgyIiAvPgogIDxwYXRoIGQ9Ik0yMiAxNXYxYTEgMSAwIDAxLTEgMUgxMCIgLz4KICA8cGF0aCBkPSJNNiAxMS4zNDFWMTAiIC8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjE3IiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/trailer
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Trailer: string = `
<svg
  class="lucide lucide-trailer"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 11.341V10" />
  <path d="M14 13v-3" />
  <path d="M18 17V8a2 2 0 00-2-2H4a2 2 0 00-2 2v7a2 2 0 002 2h2" />
  <path d="M22 15v1a1 1 0 01-1 1H10" />
  <path d="M6 11.341V10" />
  <circle cx="8" cy="17" r="2" />
</svg>
`;

export default Trailer;
